/**
 * Spots - Displays contextual spotlight action cards
 * Cards trigger questions when clicked
 */
export default function Spots({ spots, mode = 'full' }) {
  if (!spots || spots.length === 0) return null;
  const isSmallSurface = mode === 'compact' || mode === 'mobile';
  const isExpandedSurface = mode === 'expanded' || mode === 'full';

  const handleSpot = (spot) => {
    window.dispatchEvent(
      new CustomEvent('spot', {
        detail: {
          query: spot.query,
          source: 'spot',
          answer_id: spot.answer_id || null,
        },
      }),
    );
  };

  if (isSmallSurface) {
    return (
      <div className="space-y-0.5 pb-2">
        {spots.map((spot, index) => (
          <button
            key={index}
            onClick={() => handleSpot(spot)}
            data-testid="spot"
            data-query={spot.query}
            className="group flex w-full items-start gap-3 rounded-xl px-3 py-3 text-left transition-all hover:bg-white hover:shadow-sm hover:shadow-stone-200/60"
          >
            <div className="mt-0.5 text-sm shrink-0 opacity-60" aria-hidden="true">
              {spot.emoji}
            </div>

            <div className="min-w-0 flex-1">
              <h3 className="text-[13.5px] font-semibold leading-5 text-slate-800 transition-colors group-hover:text-amber-700">
                {spot.label}
              </h3>
              <p className="mt-0.5 text-[12px] leading-5 text-slate-400 line-clamp-1">
                {spot.query}
              </p>
            </div>
          </button>
        ))}
      </div>
    );
  }

  return (
    <div
      className={`grid gap-3 ${isExpandedSurface ? 'grid-cols-1 sm:grid-cols-3' : 'grid-cols-1 sm:grid-cols-2'}`}
    >
      {spots.map((spot, index) => (
        <button
          key={index}
          onClick={() => handleSpot(spot)}
          data-testid="spot"
          data-query={spot.query}
          className="group relative min-h-[148px] rounded-[18px] border border-slate-200 bg-white p-4 text-left transition-all hover:border-amber-300 hover:shadow-md"
        >
          <div className="flex items-start gap-3">
            <div className="text-2xl" aria-hidden="true">
              {spot.emoji}
            </div>

            <div className="flex-1 min-w-0">
              <h3 className="mb-1 text-[14px] font-medium text-slate-800 transition-colors group-hover:text-amber-700">
                {spot.label}
              </h3>
              <p className="line-clamp-2 text-[13px] leading-5 text-slate-500">{spot.query}</p>
            </div>

            <svg
              className="h-4 w-4 shrink-0 text-slate-300 transition-all group-hover:translate-x-0.5 group-hover:text-yellow-500"
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24"
            >
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M9 5l7 7-7 7" />
            </svg>
          </div>
        </button>
      ))}
    </div>
  );
}
